export class LocalKeyProvider {
    crypto;
    keypair;
    constructor(crypto, keypair) {
        this.crypto = crypto;
        this.keypair = keypair;
    }
    async getPlenumKeyPair() {
        const exportedKey = await this.crypto.exportKey('pkcs8', this.keypair.privateKey);
        const exportedKeyStr = String.fromCharCode(...new Uint8Array(exportedKey));
        const encodedKey = window.btoa(exportedKeyStr);
        const keyPem = `-----BEGIN PRIVATE KEY-----\n${encodedKey}\n-----END PRIVATE KEY-----`;
        return {
            pem: { pemFileContents: keyPem }
        };
    }
    async getEncodedPublicKey() {
        // export the public key from the keypair.
        const publicKeyBytes = await this.crypto.exportKey('raw', this.keypair.publicKey);
        // base64 encode the public key bytes.
        const publicKeyStr = String.fromCharCode(...new Uint8Array(publicKeyBytes));
        const encodedPublicKey = window.btoa(publicKeyStr);
        return window.btoa(`okp-nistp384 ${encodedPublicKey}`);
    }
    getPrivateCryptoKey() {
        return this.keypair.privateKey;
    }
}
